import { skipToken } from "@tanstack/react-query";

import { ProductAvailability } from "../../../../commons/libs/externals/veloconnect-proxy";
import { isProductOfType } from "../../../../commons/libs/products";
import { getVeloconnectErrorType, getVeloconnectProductDetails } from "../../../../commons/libs/veloconnect-service";
import { Product, ProductId, ProductType } from "../../../../commons/specs/product";
import useQuery from "../hooks/use-query";

/** A hook that fetches the Veloconnect Product Availabilities for a given product and provides utility functions to interact with it. */
const useVeloconnectProductAvailabilities = (product: Product) => {
  // TODO: BCD-7063 Veloconnect mit CustomerGroup o. ProductType assoziieren
  const isBicycle = isProductOfType(product, ProductType.Bicycle);

  const query = useQuery<ProductAvailability[]>({
    queryKey: ["veloconnect-product-availabilities", product, isBicycle] as const,
    queryFn: isBicycle ? async () => getVeloconnectProductDetails(product) : skipToken,
    onError: error => console.error("Error fetching Veloconnect product availabilities", error)
  });

  const getAvailabilityByVariant = (variantId: ProductId) =>
    (query.data || []).find(variant => variant.variantId === variantId);

  return {
    query,
    error: getVeloconnectErrorType(query.error),
    getAvailabilityByVariant
  };
};

export type UseVeloconnectProductAvailabilitiesReturn = ReturnType<typeof useVeloconnectProductAvailabilities>;

export default useVeloconnectProductAvailabilities;
